export const Label = ({
  title,
  additionalElements,
  className,
}: {
  title: string
  additionalElements?: React.ReactNode
  className?: string
}) => {
  return (
    <div className={`w-full italic p-2 ${className}`}>
      <p dangerouslySetInnerHTML={{ __html: title }} />
      {additionalElements}
    </div>
  )
}
